import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { EdMark } from "./EdLogo";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const Footer = () => {
  return (
    <footer className="relative pb-28 pt-20 sm:pb-12">
      <div className="mx-auto max-w-6xl px-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="glass glow-card flex flex-col items-center gap-8 rounded-[2rem] p-8 text-center sm:p-12"
        >
          <EdMark className="w-32" />
          <p className="max-w-md font-display text-xl font-bold leading-snug sm:text-2xl">
            Vamos construir o próximo nível
            <span className="text-brand-neon"> juntos?</span>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href={waLink(WA_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="inline-flex items-center gap-2.5 rounded-full bg-wa px-7 py-3.5 font-display text-sm font-bold text-ink transition-transform duration-300 hover:scale-105 active:scale-95"
            >
              <MessageCircle className="h-5 w-5" strokeWidth={2.4} />
              Chamar no WhatsApp
            </a>
          </div>
          <p className="flex flex-wrap items-center justify-center gap-2 font-display text-[10px] font-bold uppercase tracking-[0.35em] text-mist">
            Growth <span className="text-brand-neon">/</span> Design{" "}
            <span className="text-brand-neon">/</span> Web{" "}
            <span className="text-brand-neon">/</span> AI
          </p>
        </motion.div>

        <p className="mt-8 text-center text-[11px] tracking-wide text-mist/60">
          ED LABS © {new Date().getFullYear()} — Growth &amp; Technology
        </p>
      </div>
    </footer>
  );
};

export default Footer;
